// Global packages and components
import { clsx } from 'clsx'
import { ListBulletIcon, ViewColumnsIcon } from '@heroicons/react/24/outline'

// Types
interface Props {
  activeDisplay: string | null
  setDisplay: (e: string) => void
}

// Main export
const DisplayAs = ({ activeDisplay, setDisplay }: Props) => (
  <div className="flex items-center gap-3">
    <p className="mb-0 text-sm text-gray-500">View as:</p>
    <div className="flex gap-3">
      <button
        onClick={() => setDisplay('list')}
        aria-label="View as list"
        aria-pressed={activeDisplay == 'list'}
        className={clsx(
          'flex size-12 items-center justify-center rounded-lg bg-neutral-150 hover:text-teal-green',
          {
            'text-teal-green': activeDisplay == 'list',
          }
        )}
      >
        <ListBulletIcon className="size-6" />
      </button>
      <button
        onClick={() => setDisplay('grid')}
        aria-label="View as grid"
        aria-pressed={activeDisplay == 'grid'}
        className={clsx(
          'flex size-12 items-center justify-center rounded-lg bg-neutral-150 hover:text-teal-green',
          {
            'text-teal-green': activeDisplay == 'grid',
          }
        )}
      >
        <ViewColumnsIcon className="size-6" />
      </button>
    </div>
  </div>
)

export default DisplayAs
